module.exports = __webpack_public_path__ + "static/media/climbing_view_1600.24c72159.webp";